import React from "react";
import { useSelector } from "react-redux";
import { decodeHtml } from "../../components/util";
import Team from "./Team";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const AboutMain = () => {
  const { page } = useSelector((state) => state.data);
  const history = useHistory();

  const rawHtml1 = page.data["about-us-2"]?.htmlContent || "";
  const rawHtml2 = page.data["process-about-us-2"]?.htmlContent || "";
  // const rawHtml3 = page.data["teams-about-us-2"]?.htmlContent || "";

  const htmlContent = decodeHtml(rawHtml1);
  const htmlContent2 = decodeHtml(rawHtml2);
  // const htmlContent3 = fixImagePaths(decodeHTML(rawHtml3));

  return (
    <React.Fragment>
      <div
        onClick={(e) => {
          const link = e.target.closest("a.learn-more");
          if (link) {
            e.preventDefault();
            history.push("/contact");
            window.scrollTo(0, 0);
          }
        }}
        id="rs-about"
        className="rs-about gray-bg pt-120 pb-120 md-pt-80 md-pb-80"
      >
        {htmlContent && (
          <div id="extraP" dangerouslySetInnerHTML={{ __html: htmlContent }} />
        )}
      </div>

      <div className="rs-process style2 pt-120 pb-112 md-pt-80 md-pb-72">
        {htmlContent2 && (
          <div id="extraP" dangerouslySetInnerHTML={{ __html: htmlContent2 }} />
        )}
      </div>

      {/* <div id="rs-team" className="rs-team pt-120 pb-120 md-pt-80 md-pb-80 xs-pb-54">
        {htmlContent3 && <div dangerouslySetInnerHTML={{ __html: htmlContent3 }} />}
      </div> */}
      <Team />
    </React.Fragment>
  );
};

export default AboutMain;
